const getters = {
    sidebar: state => state.app.sidebar,
    rule:state => state.custom.rule,
    info:state => state.professor.info
}

export default getters